class viewCartErrorMessagesController {
    /* @ngInject */
    constructor() {
    }

    getErrorClass() {

        if(this.shoppingCartForm.$invalid) {
            return this.errorTypes.CART_ERROR;
        }

        return this.cartErrors;
    }
}

export default viewCartErrorMessagesController;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-error-messages/view-cart-error-messages.controller.js